const messages = {
  title: "Cenníky a produktové brožúry",
  description:
    "Stiahnite si najnovšie brožúry a letáky o našich pneumatikách Bridgestone a Firestone pre osobné autá, SUV a ľahké úžitkové vozidlá.",
  brochureCategories: {
    products: "Produkty",
    brand_and_solutions: "Značka a riešenia",
    season_and_promotions: "Sezóna a akcie",
    format: "Formát",
    cars_and_vans: "Osobné auto, SUV, úžitkové",
    summer: "Letné",
    winter: "Zimné",
    promotions: "Akcie",
    all_season: "Celoročné",
    truck_and_buses: "Nákladné auto a autobus",
    motorcycle: "Motocykel",
    agriculture: "Poľnohospodárstvo",
    construction_machinery: "Stavebné stroje",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiály",
    brochures: "Produktové brožúry",
    price_list: "Cenníky",
    materials: "Materiály",
    video_in_store: "Video s titulkami",
    video_online: "Video bez titulkov",
    banner_website: "Banner",
    banner_social_media: "Sociálne siete",
    logos: "Logá",
  },
  searchMedia: "Zadajte kľúčové slovo",
  searchResults: "Výsledky vyhľadávania",
};

export default {
  messages,
};
